import _objectWithoutProperties from "/home/bamboo/bamboo-agent-home/xml-data/build-dir/WEC-SIN33-JOB1/packages/web/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["title", "titleId"];
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import * as React from "react";
function Flight(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 16,
    height: props.size || 16,
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12.67 20.09l2.5.64v-.243l-1.478-1.478a1.002 1.002 0 01-.293-.707v-5.836c0-.321.155-.623.416-.812a.996.996 0 01.9-.136l6.785 2.26v-.843l-7.58-4.26a1.003 1.003 0 01-.51-.872V4.288c0-1.055-.76-1.256-1.085-1.293L12.077 3c-.23.032-.988.233-.988 1.288v3.515c0 .36-.195.694-.51.872l-7.58 4.26v.843l6.785-2.26a.996.996 0 011.316.948v5.836a.997.997 0 01-.293.707l-1.478 1.478v.243l2.5-.64c.1-.024.453-.1.84 0m3.5 2.928a.99.99 0 01-.246-.031l-3.673-.94-3.673.94a1.003 1.003 0 01-1.248-.969v-1.946c0-.265.106-.52.293-.707L9.1 17.888v-4.034l-6.784 2.26A.996.996 0 011 15.166V12.35a1 1 0 01.51-.872l7.579-4.26v-2.93c0-2.23 1.737-3.185 2.904-3.284L12.422 1c1.252.103 2.989 1.059 2.989 3.288v2.93l7.579 4.26a1 1 0 01.51.872v2.816a.999.999 0 01-1.317.948l-6.784-2.26v4.034l1.479 1.477c.187.188.292.442.292.707v1.946a1.002 1.002 0 01-1 1",
    fill: props.color || "#222",
    fillRule: "evenodd"
  }));
}
var MemoFlight = React.memo(Flight);
export default MemoFlight;